/**
 * Created by mac on 12/23/20
 */

const GroundedView = cc.Sprite.extend({
    ctor: function (grounded) {
        this.grounded = grounded;
        this._super(GroundedView.getImage(grounded.unit.x, grounded.unit.y));
    },

    onRemove: function (silent) {
        if (silent) {
            this.removeFromParent();
        } else {
            this.runAction(
                new cc.Sequence(
                    new cc.FadeOut(0.5),
                    new cc.RemoveSelf()
                )
            );
        }
    },

    highlight: function () {
        this.light = new Highlight(this.grounded.unit.x, this.grounded.unit.y, {
            unit: this.grounded.unit
        });
        const highlightView = new HighlightView(this.light);
        this.addChild(highlightView, 1);
        highlightView.setAlignment(this.width / 2, this.height / 2);
    },

    unhighlight: function () {
        if (this.light) {
            this.light.remove();
            delete this.light;
        }
    },

    canSmile: function () {
        return false;
    }
});

GroundedView.getImage = function (x, y) {
    const terrain = Map2d.currentMap.getTerrainCode(x, y);
    const tiles = cleverapps.meta.getSelectedLocation().meta.tiles;
    return bundles[`grounded_${tiles}`].frames[`grounded_${Map2d.TERRAINS[terrain]}`];
};